import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import Image from "next/image";
import Link from "next/link";
import mattildaImg from "../../public/images/partners/menfis_mattilda_flyer.png";



const Mattilda = () => {
  return (
    <>
      <PageHead title="Mattilda/Pagos - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <div className=" bg-color-white rbt-section-gapTop">
            <div className="container">
              <div className="row g-5 align-items-center">
                <div className="col-lg-6">
                  <Image
                    className="w-100 rbt-radius"
                    src={mattildaImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="Mattilda flyer"
                  />
                </div>
                <div className="col-lg-6">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <div className="section-title text-start">
                      <p className="description mt--30 mb--15">
                        ¡Hola! 
                      </p>
                      <p className="description mt--15">
                        Te invitamos a revisar tu correo electrónico registrado con Menfis. El equipo de Mattilda te enviará una invitación para unirte a nuestra nueva plataforma de pago en línea, diseñada para facilitar tu proceso de pago. En esta página tendrás información para resolver tus dudas. ¡Go Menfis!
                      </p>
                      <h4 className="title">¿Qué es Mattilda?</h4>
                      <p className="description mt--30">
                        Mattilda es una plataforma moderna y digital que facilitará la gestión de tus pagos, adaptándose a sus necesidades con los siguientes medios disponibles:
                      </p>
                      <div className="rbt-feature-wrapper mt--40">
                        <div className="rbt-feature feature-style-1 align-items-center">
                          <div className="icon bg-primary-opacity">
                            <i className="feather-check-square"></i>
                          </div>
                          <div className="feature-content">
                            <h6 className="feature-title">Tarjetas de débito o crédito (todas las franquicias)</h6>
                          </div>
                        </div>
                        <div className="rbt-feature feature-style-1 align-items-center">
                          <div className="icon bg-secondary-opacity">
                            <i className="feather-check-square"></i>
                          </div>
                          <div className="feature-content">
                            <h6 className="feature-title">Efectivo en Corresponsal Bancario de Bancolombia</h6>
                          </div>
                        </div>
                        <div className="rbt-feature feature-style-1 align-items-center">
                          <div className="icon bg-primary-opacity">
                            <i className="feather-check-square"></i>
                          </div>
                          <div className="feature-content">
                            <h6 className="feature-title">Sucursal Virtual Personas Bancolombia</h6>
                          </div>
                        </div>
                        <div className="rbt-feature feature-style-1 align-items-center">
                          <div className="icon bg-secondary-opacity">
                            <i className="feather-check-square"></i>
                          </div>
                          <div className="feature-content">
                            <h6 className="feature-title">PSE</h6>
                          </div>
                        </div>
                        <div className="rbt-feature feature-style-1 align-items-center">
                          <div className="icon bg-primary-opacity">
                            <i className="feather-check-square"></i>
                          </div>
                          <div className="feature-content">
                            <h6 className="feature-title">Nequi</h6>
                          </div>
                        </div>
                        <p className="description mt--30">
                          Además, Mattilda consolidará toda tu información en un solo lugar. Podrás acceder fácilmente a tus estados de cuenta, facturas y cuentas por pagar a través de un portal intuitivo y fácil de usar.
                        </p>
                        <Link 
                          className="rbt-moderbt-btn mb--30" 
                          href='https://familia.mattilda.io/' 
                          target="_blank"> 
                            Realiza tus pagos aquí
                        </Link>
                        <h4 className="title">Capacitación en Vivo</h4>
                        <p className="description mt--30 mb--15">
                          Agradecemos su comprensión y colaboración mientras hacemos esta transición hacia una forma más moderna y eficiente de gestionar los pagos para tu comodidad.
                        </p>
                        <p className="description mt--15">
                          Para ayudarte a familiarizarte con la nueva plataforma, puedes inscribirte en una capacitación en vivo a través del siguiente enlace:
                        </p>
                        <Link 
                          className="rbt-moderbt-btn" 
                          href='https://event.webinarjam.com/register/8/7pgn8sl?utm_source=MENFIS' 
                          target="_blank"> 
                            Inscríbete
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-center mt--30 mb--30 ">
                  <video width="360" height="520" poster="/images/partners/mattilda_video_cover_1.png" controls>
                    <source src="/video/mattilda.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default Mattilda;
